import { Address } from "../practice/address";
import { Insurance } from "../insurance";
import { Language } from "../languages";
import { GlobalHealthSystem } from "../healthSystem/global-health-system";
import { GlobalLocation } from "../healthSystem/global-location";
import { PractitionerSymptom } from "./practitioner-symptom";
import { PractitionerTreatment } from "./practitionerTreatment";
import { WorkingHours } from "../workinghours";
import { SpecialtyCategories } from "../specialty-categories";
import { SpecializationCategories } from "../specialization-categories";
import { SpecialitySubCategories } from "../speciality-sub-categories";
import { Specialty } from "../../specialty";
import { PSpecialty } from "../p-specialty";

export class Practitioner {
  id: number;
  appyId: string;
  active: boolean;
  firstName: string;
  lastName: string;
  practiceName: string;
  primaryPhoneNumber: string;
  secondaryPhoneNumber: string;
  primaryEmailAddress: string;
  gender: string;
  birthDate: string | null;
  photoUrl: string;
  bio: string;
  boardCertified: boolean;
  practiceWebsite: string;
  title: string;
  humanTouch: string;
  addressId: number | null;
  address2Id: number | null;
  isSpecialist: boolean | null;
  isFavorite: boolean | null;
  faxNumber: string;
  fullName: string;
  middleName: string;
  specialty: string;
  subSpecialty: string;
  specialization: string;
  practitionerSymptoms: PractitionerSymptom[];
  practitionerTreatments: PractitionerTreatment[];
  npi: string;
  practiceHours: string;
  notes: string;
  lastUpdatedOn: string;
  practitionerLanguages: Language[] = [];
  hospitalAffiliation: GlobalHealthSystem[] = [];
  hospitalAffiliationNumber: string;
  hospitalAffiliationAddress: string;
  patientVideoUrl: string;
  primarySpecialtyId: number | null;
  education: string;
  practitionerName: string;
  profileClaimed: boolean | null;
  profileClaimedBy: number | null;
  isAcceptingNewPatient: boolean | null;
  deceasedDate: string | null;
  suffix: string | null;
  healthSystemIds: number[] = [];
  role: string;
  roleCategory: string;
  userId: number;
  location: GlobalLocation = new GlobalLocation();
  address: Address = new Address();
  healthSystems: GlobalHealthSystem[] = [];
  practitionerInsurance: Insurance[] = [];
  practitionerType: number = 0;
  legalPracticeId: number;
  workingHours: WorkingHours[] = [];
  awards: string;
  certifications: string;
  socialMedia: string;
  showContactInfo: boolean;
  specialities: PSpecialty[] = [];
  specialitySubCategories: SpecialitySubCategories[] = [];
  subSpecialties: PSpecialty[] = [];
}
